<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OVSreL/tc-custom/9780814346464.jpg?1725909133314" alt="This image is the cover for the book Saint Peter and the Goldfinch, Made in Michigan Writers Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saint Peter and the Goldfinch, Made in Michigan Writers Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>A collection of meditations and reflections on being.</b> </p><p>Jack Ridl returns with a collection of poems that mix deft artistic skill with intimate meditations on everyday life, whether that be curiosity, loss, discovery, joy, or the passing of the seasons. An early reader of <i>Saint Peter and the Goldfinch</i>said it best: "Ridl's books are all treasures, as is he, and his poetry has always been trout-quick, alternately funny and wondrous, instantly intimate, and free of pretense. All these characteristics can be found in this book, and there is something else, something extraordinary: at an age where most poets are content to roll out an imagined posterity, he's decided to push and refine the art, to see out the day and live it fully, because art and life settle for no less."</p><p>The first section of <i>Saint Peter and the Goldfinch</i> reflects on the author's personal history, with poems like "Feeding the Pup in the Early Morning" and "Some of What Was Left After Therapy." The second section continues with meditations on varied events and persons and includes poems such as "The Last Days of Sam Snead" and "Coffee Talks with Con Hilberry." The third attends primarily to the mystery of love and what one loves and contains the poems "The Inevitable Sorrow of Potatoes" and "Suite for the Long Married." The fourth and final section meditates primarily on the imagined in poems like "Over in That Corner, the Puppets" and "Meditation on a Photograph of a Man Jumping a Puddle in the Rain." </p><p> <i>Saint Peter and the Goldfinch</i>is the work of a talented and seasoned poet, one whose work comes out of the "plainspoken" tradition—the kind of poetry that, as Thomas Lynch puts it, "has to deliver the goods, has to say something about life, something clear and discernible, or it has little to offer." Readers of poetry who enjoy wrestling with life's big questions will appreciate the space that Ridl allows for these ruminations.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Ridl
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41d746ba